import React, { Component } from 'react'
import { Button, Collapse } from 'reactstrap'
import { ErrorMessage, PasswordOverride } from './'
import resetPassword from '../../../../../../helpers/users/manageUsers/resetPassword';
import { BeatLoader } from 'react-spinners'
import pingPasswordFunc from '../../../../../../helpers/users/manageUsers/pingPasswordFunc'

class PasswordReset extends Component {
  state = {
    sending: false,
    error: '',
    sent: false,
    overriding: false,
  }

  componentDidMount() {
    const { record } = this.props
    if (record && record.role) {
      pingPasswordFunc(record.role).catch(err => console.log(err))
    }
  }

  sendReset = () => {
    const { record } = this.props
    this.setState({sending: true, error: '', sent: false})
    resetPassword(record)
      .then(() => this.setState({sending: false, error: '', sent: true}))
      .catch((err) => {
        this.setState({sending: false, error: 'Error resetting password.', sent: false})
      })
  }

  cancelOverride = () => this.setState({overriding: false, error: ''})
  openOverride = () => this.setState({overriding: true, sent: false, error: ''})

  render() {
    const { record } = this.props
    const { sending, error, sent, overriding } = this.state

    return (
      <div className='reset-override'>
        {/* <div style={{display: 'inline-block'}}> */}
        <Collapse isOpen={!overriding}>
        
        Password:
        <div className='reset-override-buttons'>
          {record
            ? <Button
            style={{"borderRadius":"150px","width":"100px"}}
               className='password-reset'
                onClick={this.sendReset}
                disabled={!!(sent || sending)}
              >
                {sending
                  ? <BeatLoader loading={sending} />
                  : (sent ? 'Reset Sent' : 'Reset')
                }
              </Button>
            : null
          }
          <Button style={{"borderRadius":"150px"}} onClick={this.openOverride} className='override'>Override</Button>
          </div>
        </Collapse>
        <Collapse isOpen={!!overriding}>
          <PasswordOverride cancelOverride={this.cancelOverride} record={record}/>
        </Collapse>
        {error
          ? <ErrorMessage>{error}</ErrorMessage>
          : null
        }
        </div>
      // </div>
    )
  }
}

export default PasswordReset


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/PasswordReset.js